import React from 'react';

export default function ShieldCrossIcon() {
    return (
        <svg
            width="104"
            height="128"
            viewBox="0 0 104 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_866_59443)">
                <path
                    d="M47.6376 124.123C49.0213 124.924 49.7131 125.325 50.6895 125.533C51.4472 125.694 52.5528 125.694 53.3105 125.533C54.2869 125.325 54.9787 124.924 56.3624 124.123C68.5378 117.075 102 94.9361 102 64.4961V34.8379C102 29.8796 102 27.4005 101.183 25.2695C100.461 23.3869 99.2876 21.7072 97.7646 20.3754C96.0407 18.8679 93.7013 17.9974 89.0225 16.2564L55.5112 3.78714C54.2119 3.30366 53.5622 3.06192 52.8938 2.96609C52.301 2.88109 51.699 2.88109 51.1061 2.96609C50.4378 3.06192 49.7881 3.30366 48.4888 3.78714L14.9775 16.2564C10.2987 17.9974 7.95935 18.8679 6.23536 20.3754C4.71239 21.7072 3.53922 23.3869 2.81725 25.2695C2 27.4005 2 29.8796 2 34.8379V64.4961C2 94.9361 35.4623 117.075 47.6376 124.123Z"
                    stroke="#0080FF"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M74 33L30 77M30 33L74 77"
                    stroke="#0080FF"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_866_59443">
                    <rect
                        width="104"
                        height="128"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
